import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useLocation } from 'react-router';

interface NavContextProps extends PropsWithChildren {
  navigationHistory: string[];
}

const NavigationHistoryContext = createContext<NavContextProps | undefined>(
  undefined
);

const NavigationHistoryProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [navigationHistory, setNavigationHistory] = useState<string[]>([]);
  const location = useLocation();

  const pathname = location.pathname;

  useEffect(() => {
    setNavigationHistory((prevHistory) => {
      const historyParsed =
        prevHistory && Array.isArray(prevHistory) && prevHistory.length
          ? prevHistory
          : [];

      return historyParsed.at(-1) !== pathname
        ? [...prevHistory, pathname]
        : historyParsed;
    });
  }, [pathname]);

  return (
    <NavigationHistoryContext.Provider value={{ navigationHistory }}>
      {children}
    </NavigationHistoryContext.Provider>
  );
};

const useNavigationHistory = (): NavContextProps => {
  const context = useContext(NavigationHistoryContext);

  if (!context) {
    throw new Error(
      'useNavigationHistory must be used within a NavigationHistoryProvider'
    );
  }

  return context;
};

export { NavigationHistoryProvider, useNavigationHistory };
